import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ITrade } from '../interface/trade/ITrade';
import { IRequestUpdateTradeOperationCost } from '../interface/trade/IRequestUpdateTradeOperationCost';

enum OperationCostServiceEnum {
	getAll = '/',
	updateTradeCost = '/trade/',
	getOperationCostByTradeId = '/trade/'
}

export default class OperationCostService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/operation-cost');
	}
	public getAllOperationCost = async (): Promise<ITrade[]> => await this.GET(OperationCostServiceEnum.getAll);
	public getOperationCost = async (idTrade: number): Promise<ITrade> => await this.GET(`${OperationCostServiceEnum.getOperationCostByTradeId}${idTrade}`);
	public updateOperationCost = async (request: IRequestUpdateTradeOperationCost, idTrade: number): Promise<IRequestUpdateTradeOperationCost> =>
		await this.PUT(`${OperationCostServiceEnum.updateTradeCost}${idTrade}`, request);
}
